export default __webpack_public_path__ + "static/media/image-placeholder.7f749ca2.png";